import { useEffect, useRef } from "react"
import { SEASON } from "../config"

export const Contests = () => {
    const containerRef = useRef(null)

    useEffect(() => {
        const link = document.createElement('link')
        link.rel = 'stylesheet'
        link.href = 'https://testevents.yes35.ru/events.css'
        document.head.appendChild(link)

        const script = document.createElement('script')
        script.src = 'https://testevents.yes35.ru/events.js'
        script.async = true
        containerRef.current?.appendChild(script)

        return () => {
            link.remove()
            script.remove()
        }
    }, [])
    return (
        <div id='contests' className='text-center'>
            <div className='container'>
                <div className='section-title'>
                    <h2>Соревнования</h2>
                </div>
                <div ref={containerRef}>
                    <div id="iframe-events" data-type="contests" data-direction={SEASON}></div>
                </div>
            </div>
        </div>
    )
}
